import { StatusBookings } from './bookings.interface';

export type ExportExtensions = 'xlsx' | 'csv';

export interface PendingBookingsExport {
  recordLocator: string;
  origin: string;
  destination: string;
  departureDate: Date;
  returnDate: Date | undefined;
  amount: number | undefined;
}

export interface CancelledBookingsExport {
  recordLocator: string;
  status: string;
  amount: number | undefined;
}

export interface ExportConfiguration {
  headers: string[];
  worksheetName: string;
  fileName: string;
}

export interface CreditFlightBookingsExport {
  recordLocator: string;
  passengerCount: number;
  availableCredit?: number;
  usedCredit?: number;
  status: StatusBookings;
}

const DefaultBookingsExportHeaders = ['RecordLocator', 'FromCity', 'ToCity', 'DepartureDate', 'ReturnDate', 'Amount'];
const CancelledBookingsExportHeaders = ['RecordLocator', 'Status', 'Amount'];
const BookingsCreditFlightExportHeaders = ['RecordLocator', 'PassengerCount', 'AvailableCredit', 'UseCredit', 'Status'];

export const defaultExportConfiguration: ExportConfiguration = {
  headers: DefaultBookingsExportHeaders,
  worksheetName: 'Booking List',
  fileName: 'Booking Details'
};

export const cancelledExportConfiguration: ExportConfiguration = {
  ...defaultExportConfiguration,
  headers: CancelledBookingsExportHeaders
};

export const bookingCreditFlightConfiguration: ExportConfiguration = {
  headers: BookingsCreditFlightExportHeaders,
  worksheetName: 'Booking List',
  fileName: 'Booking Details'
};

export interface TextLinkConfiguration {
  label: string;
  icon: string;
}

export interface ExportButtonConfiguration {
  CSV: TextLinkConfiguration;
  XLSX: TextLinkConfiguration;
}

export const textLinkConfiguration: ExportButtonConfiguration = {
  CSV: {
    label: 'booking_list_component.download_csv',
    icon: 'ds-icon-download'
  },
  XLSX: {
    label: 'booking_list_component.download_excel',
    icon: 'ds-icon-download'
  }
};
